<template>
  <div>
    <!-- El popup de Google One Tap se renderiza automáticamente por la librería -->
    <div id="g_id_onload"></div>
  </div>
</template>

<script>
import { http } from '@/services/config';

export default {
  name: 'GoogleOneTap',

  data() {
    return {
      // Usar el mismo GOOGLE_CLIENT_ID que ya está en el .env del backend
      // Se puede externalizar a un .env del frontend si se desea
      clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID || ''
    };
  },

  computed: {
    estaLogueado() {
      return this.$store.getters.estaLogueado;
    }
  },

  mounted() {
    // Solo mostrar si no está logueado y hay clientId configurado
    if (this.estaLogueado || !this.clientId) return;

    this.cargarGoogleScript();
  },

  methods: {
    cargarGoogleScript() {
      // Evitar cargar el script dos veces
      if (document.getElementById('google-gsi-script')) {
        this.inicializarOneTap();
        return;
      }

      const script = document.createElement('script');
      script.id = 'google-gsi-script';
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.inicializarOneTap();
      };
      document.head.appendChild(script);
    },

    inicializarOneTap() {
      if (!window.google || !window.google.accounts) return;

      window.google.accounts.id.initialize({
        client_id: this.clientId,
        callback: this.handleCredentialResponse,
        auto_select: false,  // no auto-login, solo mostrar prompt
        cancel_on_tap_outside: true
      });

      // Mostrar el prompt One Tap
      window.google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed()) {
          console.log('One Tap no mostrado:', notification.getNotDisplayedReason());
        }
        if (notification.isSkippedMoment()) {
          console.log('One Tap omitido:', notification.getSkippedReason());
        }
      });
    },

    handleCredentialResponse(response) {
      // response.credential contiene el JWT id_token de Google
      if (!response.credential) return;

      http.post('/api/login/google-onetap', {
        credential: response.credential
      }, { skipAuthInterceptor: true })
        .then(res => {
          const data = res.data.data;
          localStorage.setItem('token', data.token);
          this.$store.commit('setIdentificador', data.identificador);
          this.$store.commit('setLinkPhoto', data.linkPhoto || '');
          this.$store.commit('setRoles', data.roles || []);
          this.$store.commit('setLogueado', true);

          // Notificar al usuario
          this.$emit('login-exitoso');
        })
        .catch(err => {
          console.error('Error Google One Tap login:', err);
        });
    }
  }
};
</script>
